import styled, { css } from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { Row } from '../../../../styles/customComponents';

export const CategoryHeader = styled(Row)`
  ${({ isDragDisabled, disabled }) => {
    if (isDragDisabled) {
      if (!disabled) {
        return 'cursor: pointer;';
      }

      return 'cursor: default;';
    }
  }}

  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })};
  height: ${({ isDragging }) => (isDragging ? '76px' : '97px')};
`;

export const CategoryTitle = styled.label`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_3,
    styles.fontWeights.SEMIBOLD
  )}

  margin-left: ${({ isDragging }) => (isDragging ? '0' : ' 43px')};
`;

export const CheckboxContainer = styled.div`
  > div {
    display: block;
  }
`;

export const CategoryTitleContainer = styled.div`
  ${mixins.flexPosition({ align: 'center' })};

  form {
    margin: -1px 0 0 32px;
  }

  ${({ isDragging }) =>
    isDragging &&
    css`
      > div,
      .checkbox-4all {
        display: none;
      }

      form {
        margin-left: 0;
      }

      input {
        width: 270px !important;
      }
    `}

  label {
    margin-bottom: 0;

    &.checkbox-4all > span:first-child {
      margin-right: 0;
    }
  }
`;

export const CategoryActions = styled.div`
  ${({ isDragging }) =>
    isDragging &&
    css`
      visibility: hidden;
      position: absolute;
      right: 0;
    `}

  ${mixins.flexPosition({
    align: 'center',
    justify: 'flex-end',
  })}
  button {
    margin-right: 50px;
  }
`;

export const Input = styled.input`
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_3,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 1;
  min-width: 50px;
  padding: 7px 10px;
  transition: width 300ms ease;
  max-width: 800px;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    border-color: ${styles.colors.GRAY_LIGHT_2};
    width: 270px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/Header/style.js